export async function handleApiError(response) {
    if (response && response.status === 401) {
        window.location.href = "/login";
    } else if (!response || !response.ok) {
        throw new Error("Network response was not ok");
    }
}
